import React, { useEffect, useRef } from 'react';

type ClickAwayListenerProps = {
    shouldListen?: boolean;
    onClickAway: () => void;
    children: React.ReactNode;
    exceptions?: string[];
    className?: string;
};

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({ 
    shouldListen = true, 
    onClickAway, 
    children, 
    exceptions = [],
    className
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!shouldListen) return;

        const handleDocumentMouseDown = (e: MouseEvent) => {
            
            const root = containerRef.current;
            if (!root) return;
            const targetEl = e.target as Element | null;

            const ignoreSelectors = exceptions.join(', ');
            if (exceptions?.length && targetEl && targetEl.closest(ignoreSelectors)) {
                return;
            }
            if (targetEl && !root.contains(targetEl)) {
                onClickAway();
            }
        };

        document.addEventListener('mousedown', handleDocumentMouseDown, true);
        return () => {
            document.removeEventListener('mousedown', handleDocumentMouseDown, true);
        };
    }, [shouldListen, onClickAway, exceptions]);

    return <div ref={containerRef} className={className}>{children}</div>;
};

export default ClickAwayListener;


import React, { useEffect, useRef } from 'react';

type ClickAwayListenerProps = {
    shouldListen?: boolean;
    onClickAway: () => void;
    children: React.ReactNode;
    exceptions?: string[];
    className?: string;
};

const ClickAwayListener: React.FC<ClickAwayListenerProps> = ({ 
    shouldListen = true, 
    onClickAway, 
    children, 
    exceptions = [],
    className
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!shouldListen) return;

        const handleDocumentMouseDown = (e: MouseEvent) => {
            
            const root = containerRef.current;
            if (!root) return;
            const targetEl = e.target as Element | null;

            const ignoreSelectors = exceptions.join(', ');
            if (exceptions?.length && targetEl && targetEl.closest(ignoreSelectors)) {
                return;
            }
            if (targetEl && !root.contains(targetEl)) {
                onClickAway();
            }
        };

        document.addEventListener('mousedown', handleDocumentMouseDown, true);
        return () => {
            document.removeEventListener('mousedown', handleDocumentMouseDown, true);
        };
    }, [shouldListen, onClickAway, exceptions]);

    return <div ref={containerRef} className={className}>{children}</div>;
};

export default ClickAwayListener;


